import { cn } from "@istari-frontend/shared";
import { GripVerticalIcon } from "lucide-react";
import * as React from "react";
import * as ResizablePrimitive from "react-resizable-panels";

export function ResizablePanelGroup({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) {
  return (
    <ResizablePrimitive.PanelGroup
      data-slot="resizable-panel-group"
      className={cn("flex h-full w-full data-[panel-group-direction=vertical]:flex-col", className)}
      {...props}
    />
  );
}

export function ResizablePanel({ ...props }: React.ComponentProps<typeof ResizablePrimitive.Panel>) {
  return <ResizablePrimitive.Panel data-slot="resizable-panel" {...props} />;
}

export function ResizableHandle({
  withHandle,
  disabled,
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
  disabled?: boolean;
}) {
  return (
    <ResizablePrimitive.PanelResizeHandle
      data-slot="resizable-handle"
      disabled={disabled}
      className={cn(
        "group bg-border focus-visible:ring-ring hover:bg-border/80 relative flex w-[0.5px] items-center justify-center transition-[background-color,opacity] after:absolute after:inset-y-0 after:left-1/2 after:w-1.5 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:outline-hidden data-[panel-group-direction=vertical]:h-[0.5px] data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1.5 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:translate-x-0 data-[panel-group-direction=vertical]:after:-translate-y-1/2 [&[data-panel-group-direction=vertical]>div]:rotate-90",
        disabled && "hover:bg-border cursor-default opacity-50",
        className,
      )}
      {...props}
    >
      {withHandle && !disabled && <ResizableGrip />}
    </ResizablePrimitive.PanelResizeHandle>
  );
}

/**
 * The grip pill that fades in when a resize edge is hovered. Place inside a `group`
 * element so a hover anywhere on the edge, not just on the pill, reveals it.
 */
export function ResizableGrip({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "bg-border z-10 flex h-4 w-3 items-center justify-center rounded-xs border opacity-0 transition-opacity duration-200 ease-out group-hover:opacity-100",
        className,
      )}
    >
      <GripVerticalIcon className="size-2.5" />
    </div>
  );
}
